export default {"src":"/_next/static/media/ic-internet-banking.726513ec.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};